var components
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var l0 = _vm.__map(_vm.actions, function(item, index) {
    var $orig = _vm.__get_orig(item)

    var s0 = _vm.__get_style([
      item.color
        ? {
            color: item.color
          }
        : ""
    ])

    return {
      $orig: $orig,
      s0: s0
    }
  })

  if (!_vm._isMounted) {
    _vm.e0 = function($event) {
      $event.stopPropagation()
      $event.preventDefault()
      return (function() {})($event)
    }
  }

  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        l0: l0
      }
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }